import { Row, Col, Card, Button, Skeleton, Carousel, Avatar, Modal, Typography, } from "antd";
import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import { ShowToast, Severty } from "../../helper/toast";
import lang from "../../helper/lang";
import { LeftOutlined, RightOutlined, HeartOutlined, StarOutlined, MessageOutlined, UserOutlined, } from "@ant-design/icons";
const { Text } = Typography;

function View() {
  const params = useParams();
  const { request } = useRequest();
  const [list, setList] = useState({});
  const [orderList, setOrderList] = useState({});
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const fetchData = (id) => {
    setLoading(true);
    request({
      url: apiPath.viewPost + "/" + id,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChangeStatus = (id, status) => {
    setLoading(true);
    request({
      url: apiPath.statusChangeReport + id,
      method: "POST",
      data: {
        status: status,
      },
      onSuccess: (data) => {
        setLoading(false);
        ShowToast(data.data.message, Severty.SUCCESS);
        fetchData(id);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    fetchData(params.id);
  }, []);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const fullDescription = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.";

  return (
    <>
      <Card title={`${lang("Transaction")} ${lang("Detail")}`}>
        <Row gutter={16}>
          <Col span={12} xs={24} md={24}>
            {loading ? (
              [1, 2].map((item) => <Skeleton active key={item} />)
            ) : (
              <Row gutter={[24, 24]}>
                <Col span={6}>
                  <div className="scroll-bar">
                    <Carousel
                      autoplay
                      dots
                      arrows
                      prevArrow={
                        <LeftOutlined
                          style={{ fontSize: "24px", color: "#fff" }}
                        />
                      }
                      nextArrow={
                        <RightOutlined
                          style={{ fontSize: "24px", color: "#fff" }}
                        />
                      }
                    >
                      {list.files?.map((file, index) => {
                        const isVideo = file.url.match(/\.(mp4|webm|ogg)$/i);
                        return (
                          <div key={index} className="item">
                            {isVideo ? (
                              <video controls style={{ width: "100%" }}>
                                <source src={file.url} type="video/mp4" />
                              </video>
                            ) : (
                              <img src={file.url} alt="img" />
                            )}
                          </div>
                        );
                      })}
                    </Carousel>
                  </div>
                </Col>
                <Col span={18}>
                  <div className="view-main-list">
                    <div className="view-inner-cls">
                      <h5>Post caption:</h5>
                      <h6>{list?.caption}</h6>
                    </div>
                    <div className="view-inner-cls">
                      <h5>Username :</h5>
                      <h6>{list?.userDetails?.name}</h6>
                    </div>
                    <div className="view-inner-cls">
                      <h5>Email :</h5>
                      <h6>{list?.userDetails?.email}</h6>
                    </div>
                    <div className="view-inner-cls">
                      <h5>Total View :</h5>
                      <h6>{list?.totalLike}</h6>
                    </div>
                    <div className="view-inner-cls">
                      <h5>Total like :</h5>
                      <h6>{list?.totalLike}</h6>
                    </div>
                    <div className="view-inner-cls">
                      <h5>Total comment :</h5>
                      <h6>{list?.totalComment}</h6>
                    </div>
                  </div>
                </Col>
              </Row>
            )}
          </Col>
          <Button type="primary" onClick={showModal}>
            Open Story
          </Button>

          <Modal
            visible={isModalVisible}
            footer={null}
            onCancel={handleCancel}
            centered
            width={400}
            bodyStyle={{
              padding: 0,
              backgroundColor: "black",
            }}
            style={{ top: 0 }}
            className="reel-modal"
          >
            <div
              style={{
                backgroundColor: "black",
                color: "white",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              {/* Media Carousel */}
              <div style={{ position: "relative", flexGrow: 1 }}>
                <Carousel
                  autoplay
                  dots
                  arrows
                  prevArrow={
                    <LeftOutlined style={{ fontSize: "24px", color: "#fff" }} />
                  }
                  nextArrow={
                    <RightOutlined
                      style={{ fontSize: "24px", color: "#fff" }}
                    />
                  }
                >
                  {list.files?.map((file, index) => {
                    const isVideo = file.url.match(/\.(mp4|webm|ogg)$/i);
                    return (
                      <div key={index} className="item">
                        {isVideo ? (
                          <video
                            controls={true}
                            autoPlay={true}
                            muted
                            style={{ width: "100%", height: "600px" }}
                          >
                            <source src={file.url} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        ) : (
                          <img
                            src={file.url}
                            alt="img"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        )}
                      </div>
                    );
                  })}
                </Carousel>

                {/* Like and Share Buttons */}
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "15px",
                    transform: "translateY(-50%)",
                    display: "flex",
                    flexDirection: "column",
                    gap: "30px",
                  }}
                >
                  <div className="new-like-button">
                    <HeartOutlined
                      style={{ fontSize: "24px", color: "white" }}
                    />
                    <div>20</div>
                  </div>
                  <div className="new-like-button">
                    <MessageOutlined
                      style={{ fontSize: "24px", color: "white" }}
                    />
                    <div>20</div>
                  </div>
                  <div className="new-like-button">
                    <StarOutlined
                      style={{ fontSize: "24px", color: "white" }}
                    />
                    <div>20</div>
                  </div>
                </div>
              </div>

              {/* User Info and Description */}
              <div
                style={{
                  padding: "20px 30px",
                  backgroundColor: "rgba(0, 0, 0, 0.6)",
                }}
              >
                <Row align="middle" style={{ marginBottom: "10px" }}>
                  <Col>
                    <Avatar icon={<UserOutlined />} />
                  </Col>
                  <Col>
                    <Text style={{ color: "white", marginLeft: 10 }}>
                      Wade Warren
                    </Text>
                  </Col>
                </Row>
                <Row className="text-readmore-buttonhhjhj">
                  <Text style={{ color: "white", display: "block" }}>
                    <span
                      style={{
                        whiteSpace: isExpanded ? "normal" : "nowrap",
                        overflow: isExpanded ? "visible" : "hidden",
                        textOverflow: isExpanded ? "clip" : "ellipsis",
                      }}
                    >
                      {fullDescription}
                    </span>
                    <span
                      style={{
                        color: "gray",
                        cursor: "pointer",
                        marginLeft: "5px",
                      }}
                      onClick={handleToggle}
                    >
                      {isExpanded ? "Show less" : "Read more"}
                    </span>
                  </Text>
                </Row>
              </div>
            </div>
          </Modal>
        </Row>
      </Card>

      {/* <Card title="Order Detail" className="mt-3">
        <Row gutter={16}>
          <Col span={12} xs={24} md={24}>
            {loading ? [1,2,3].map(item => <Skeleton active key={item} />) :
              <div className="view-main-list">
                <Table
                  loading={loading}
                  columns={orderColumns}
                  dataSource={orderList}
                  className="ant-border-space"
                />
              </div>
            }
          </Col>
        </Row>
      </Card> */}
    </>
  );
}

export default View;
